import React, {
    useState,
    useEffect
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import {
    useNavigate
} from 'react-router-dom';

import HeaderUno from '../../Compartidos/HeaderUno';
import HeaderMetodos from '../../../AuxiliaresPaginas/HeaderMetodos';

import {
    setearListaAction
} from '../../../../actions/estadoEjercicioActions';


// css

import {
    ContenedorLetras,
    BtnLetra,
    BtnElegir
} from '../../../Css/MetodosCSS/StyledInstruccionExplicita';

import {
    ContainerFlex
} from '../../../Css/MetodosCSS/StyledLN2Todos';

import {
    HrMetodos
} from '../../../Css/StyledHeader';


const LEN41LISTA = () => {


    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const [
        checkeable,
        setCheckeable
    ] = useState([]);


    const listas_check =
        useSelector(
            state =>
                state.ejercicio.listas_check
        );


    // =========================================================
    // ELEGIR NIVEL
    // =========================================================

    const setearLista = (
        e,
        lista
    ) => {

        e.preventDefault();


        dispatch(
            setearListaAction(
                lista
            )
        );


        navigate(
            '/escritorio/metodos/lenguaje/inferencia/LEN41'
        );
    };


    // =========================================================
    // VOLVER
    // =========================================================

    const volver = (
        e
    ) => {

        e.preventDefault();


        navigate(
            '/escritorio/metodos/lenguaje/inferencia'
        );
    };


    // =========================================================
    // CARGAR LISTAS
    // =========================================================

    useEffect(() => {


        const newList =
            JSON.parse(
                JSON.stringify(
                    listas_check
                )
            );


        setCheckeable(
            newList
        );


    }, [
        listas_check
    ]);


    // =========================================================
    // RENDER
    // =========================================================

    return (

        <div
            style={{

                width:
                    '100%',

                height:
                    '100vh',

                display:
                    'flex',

                flexDirection:
                    'column',

                overflow:
                    'hidden',

                boxSizing:
                    'border-box',

                backgroundColor:
                    '#FFFFFF'
            }}
        >


            {/* ================================================= */}
            {/* HEADER SUPERIOR                                    */}
            {/* ================================================= */}

            <div
                style={{
                    flexShrink: 0
                }}
            >


                <HeaderUno />


                <HrMetodos
                    margin='0 0.2rem 0.5rem 0.2rem'
                />


                <HeaderMetodos

                    l1={"metodos/"}

                    l2={"lenguaje/"}

                    l3={"inferencia/"}

                    n1={"Métodos"}

                    n2={"LENGUAJE"}

                    n3={"INFERENCIA"}

                    componente={
                        "INFERENCIAS DE TEXTO"
                    }

                    paciente={
                        true
                    }

                    bgcolor={
                        "#FF9B2A"
                    }

                    color={
                        "white"
                    }

                    width={
                        "96vw"
                    }

                    shadow={
                        "0px 4px 4px rgba(0, 0, 0, 0.25)"
                    }

                    display={
                        "none"
                    }

                />


            </div>


            {/* ================================================= */}
            {/* ESPACIO BLANCO ENTRE HEADER Y FONDO               */}
            {/* ================================================= */}

            <div
                style={{

                    height:
                        '16px',

                    flexShrink:
                        0,

                    backgroundColor:
                        '#FFFFFF'
                }}
            />


            {/* ================================================= */}
            {/* FONDO LENGUAJE                                    */}
            {/* ================================================= */}

            <div
                style={{

                    width:
                        '100%',

                    flex:
                        1,

                    minHeight:
                        0,

                    boxSizing:
                        'border-box',

                    backgroundImage:
                        "url('/img/portadas/lenguaje_caratula_principal.jpg')",

                    backgroundSize:
                        'cover',

                    backgroundPosition:
                        'center',

                    backgroundRepeat:
                        'no-repeat',

                    display:
                        'flex',

                    justifyContent:
                        'center',

                    alignItems:
                        'center',

                    overflow:
                        'hidden'
                }}
            >


                <ContainerFlex

                    display="flex"

                    direction="column"

                    justify="center"

                    align="center"

                    width="100%"

                >


                    <ContenedorLetras

                        height="100%"

                        width="100%"

                        justify="center"

                        align="center"

                    >


                        {/* ===================================== */}
                        {/* VOLVER                                */}
                        {/* ===================================== */}

                        <BtnElegir

                            style={{

                                backgroundColor:
                                    '#FF9B2A',

                                color:
                                    'white'
                            }}

                            onClick={
                                e =>
                                    volver(
                                        e
                                    )
                            }

                        >

                            ← Volver

                        </BtnElegir>


                        {/* ===================================== */}
                        {/* NIVELES                               */}
                        {/* ===================================== */}

                        <ContenedorLetras

                            margin="1.5rem"

                            justify="center"

                            align="center"

                        >


                            {
                                checkeable

                                    .filter(
                                        item =>
                                            item.tipo ===
                                            'LEN41_niveles'
                                    )

                                    .map(
                                        item => (

                                            <div
                                                key={
                                                    item.id
                                                }
                                            >


                                                <BtnLetra

                                                    display="flex"

                                                    justify="center"

                                                    align="center"

                                                    width="13.5rem"

                                                    height="5rem"

                                                    margin="0.6rem"

                                                    font="1.8rem"

                                                    shadow="0px 4px 4px rgba(0, 0, 0, 0.25)"

                                                    widthmob="13.5rem"

                                                    heightmob="4rem"

                                                    fontmob="1rem"

                                                    marginMob="0.6rem"

                                                    transform="uppercase"

                                                    cursor="pointer"

                                                    style={{

                                                        backgroundColor:
                                                            '#FF9B2A',

                                                        color:
                                                            'white'
                                                    }}

                                                    onClick={
                                                        e =>
                                                            setearLista(
                                                                e,
                                                                item.lista
                                                            )
                                                    }

                                                >

                                                    {
                                                        item.nombre_lista
                                                    }

                                                </BtnLetra>


                                            </div>

                                        )
                                    )
                            }


                        </ContenedorLetras>


                    </ContenedorLetras>


                </ContainerFlex>


            </div>


        </div>
    );
};


export default LEN41LISTA;